export default {
  subtitle: "Transactions not wired",
  paragraph: "To check the transactions which were not wired yet, you can use this other endpoint:",
  path: "transactions_not_wired",
  request: {
    method: "GET",
    endpoint: "/transactions/not_wired",
    responses: {
    "data": [
        {
            "wire_id": null,
            "value": "10000",
            "spei_reference": null,
            "spei_concepto_de_pago": null,
            "source_type": "TED",
            "source_name": "Gustavo Rodrigues Paludetto",
            "source_id": null,
            "source_document_type": "cpf",
            "source_document_number": "21958642819",
            "source_description": "CREDITO POR TED",
            "source_branch": "1142",
            "source_bank_ispb": null,
            "source_bank": "033",
            "source_account": "130013844",
            "movement_date": "2020-07-24",
            "iof_value": "0.00",
            "inserted_at": "2020-07-24T04:57:41.400266",
            "id": "41ffbab7-0caa-42cd-8bda-4835b0a6971c",
            "exchanged_value": "10000.00",
            "exchange_rate_spot": null,
            "exchange_rate": "1.0",
            "exchange_id": "7cedd106-6e54-4ff4-9af3-f0ec725fb83d",
            "exchange_currency": "BRL",
            "exchange_approved": true,
            "currency": "BRL"
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionsNotWiredList.js